import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="relative w-full bg-[#F5F1E8] px-6 py-20 md:py-32 overflow-hidden" data-id="element-28">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-30">
          <span className="inline-block py-1 px-3 rounded-full bg-[#8B9D83]/10 text-[#6A7D63] text-sm font-semibold tracking-wide mb-6" data-id="element-31">
            FOR MOMS OF KIDS WITH SENSITIVE SKIN
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-[#2D2D2D] leading-tight mb-6" data-id="element-32">
            "We Bought Gentle… <br className="hidden md:block" data-id="element-33" />
            <span className="text-[#D4A59A] italic" data-id="element-34">
              And It Still Got Worse.
            </span>
            " <br data-id="element-35" />
            Here's Why.
          </h1>
          <p className="text-xl md:text-2xl text-[#5A5A5A] font-light max-w-2xl mx-auto leading-relaxed" data-id="element-36">
            The 14-Day Fragrance-Free Home Reset for moms who are tired of
            guessing.
          </p>
        </motion.div>

        {/* Split layout: Content + Image */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-12" data-id="element-37">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="bg-white/60 backdrop-blur-sm rounded-2xl p-8 md:p-10 shadow-sm border border-[#E5E5E5]/50" data-id="element-38">
            <p className="text-lg text-[#4A4A4A] mb-6 leading-relaxed" data-id="element-39">
              You know what makes this so exhausting? It's not the rash.{' '}
              <strong className="font-semibold text-[#2D2D2D]" data-id="element-40">
                It's the fact that it feels random.
              </strong>
            </p>
            <p className="text-lg text-[#4A4A4A] mb-6 leading-relaxed" data-id="element-41">
              You buy the "gentle" soap. You switch the lotion. You wash the
              sheets. And somehow… your child still ends up itchy, red,
              uncomfortable—especially at night.
            </p>
            <p className="text-lg text-[#4A4A4A] mb-8 leading-relaxed" data-id="element-42">
              So you start doing what every good mom does when she's out of
              options: <span className="italic" data-id="element-43">You start guessing.</span>
            </p>
            <p className="text-lg font-medium text-[#8B9D83]" data-id="element-44">
              This ebook is here to take you out of guessing—and into a simple,
              repeatable home routine you can actually maintain.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: 'easeOut'
        }} className="flex justify-center" data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/gUXqgvrnb7NFz5L3Tjm38Z/heylloyd-image-1770145122296.png" alt="The 14-Day Fragrance-Free Home Reset ebook cover" className="w-full max-w-md rounded-2xl shadow-2xl shadow-[#8B9D83]/20" data-id="element-46" />
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-center" data-id="element-47">
          <Button onClick={scrollToPricing} className="w-full md:w-auto text-lg px-10 py-5" data-id="element-48">
            Download The Reset <ArrowRight className="ml-2 h-5 w-5" data-id="element-49" />
          </Button>
          <p className="mt-4 text-sm text-[#8B9D83]/80" data-id="element-50">
            Instant PDF Download • Secure Checkout
          </p>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0" data-id="element-51">
        <div className="absolute -top-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-[#8B9D83]/5 blur-3xl" data-id="element-52" />
        <div className="absolute top-[20%] -right-[5%] w-[30%] h-[30%] rounded-full bg-[#D4A59A]/5 blur-3xl" data-id="element-53" />
      </div>
    </section>;
}